import { render, staticRenderFns } from "./RecordCount.vue?vue&type=template&id=6819c672&scoped=true&"
import script from "./RecordCount.vue?vue&type=script&lang=js&"
export * from "./RecordCount.vue?vue&type=script&lang=js&"
import style0 from "./RecordCount.vue?vue&type=style&index=0&id=6819c672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6819c672",
  null
  
)

export default component.exports